// TODO: Implement with Base UI Accordion
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, Fragment } from "react";
import * as RadixCollapsible from "@radix-ui/react-collapsible";
import { Icon } from "../Icon/index.js";
import { Typography } from "../Typography/index.js";
/**
 * Collapsible - [API](https://scl.sharp.com/?path=/docs/components-expandablecontent) | [DSM](https://sharphealthcare.notion.site/Expandable-content-item-138b8dd02e56472db057f2a358c5cfb3)
 *
 * This component is meant to be nested inside of `<ExpandableContent />`.
 */ const Collapsible = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { heading, description, slots = {}, slotProps = {}, onClick } = _param, props = _object_without_properties(_param, [
        "heading",
        "description",
        "slots",
        "slotProps",
        "onClick"
    ]);
    var _slots_headingContainer;
    const HeadingContainer = (_slots_headingContainer = slots.headingContainer) !== null && _slots_headingContainer !== void 0 ? _slots_headingContainer : slotProps.headingContainer ? 'div' : Fragment;
    const headingContainerProps = slots.headingContainer ? slotProps.headingContainer : {};
    var _slots_heading;
    const Heading = (_slots_heading = slots.heading) !== null && _slots_heading !== void 0 ? _slots_heading : Typography;
    const headingProps = slots.heading ? slotProps.heading : _object_spread({
        variant: 'h5',
        align: 'left'
    }, slotProps.heading);
    return /*#__PURE__*/ _jsxs(RadixCollapsible.Root, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(HeadingContainer, _object_spread_props(_object_spread({}, headingContainerProps), {
                children: /*#__PURE__*/ _jsxs(RadixCollapsible.Trigger, {
                    onClick: onClick,
                    className: "w-full flex flex-row items-center gap-x-8 justify-between outline-primary outline-offset-2 focus:outline-2 appearance-none group py-5",
                    children: [
                        /*#__PURE__*/ _jsx(Heading, _object_spread_props(_object_spread({}, headingProps), {
                            children: heading
                        })),
                        /*#__PURE__*/ _jsx(Icon, {
                            icon: "chevron-down",
                            className: "transition duration-200 text-primary group-data-[state=open]:-rotate-180"
                        })
                    ]
                })
            })),
            /*#__PURE__*/ _jsx(RadixCollapsible.Content, {
                className: "data-[state=closed]:animate-collapsible-close data-[state=open]:animate-collapsible-open overflow-hidden",
                children: /*#__PURE__*/ _jsx(Typography, {
                    as: "div",
                    className: "scl-rich-text mb-5",
                    children: description
                })
            })
        ]
    }));
});
export { Collapsible };
